import { CSSResult, LitElement, TemplateResult, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import css from "./maz-plushie-skin.scss";

@customElement("maz-plushie-skin")
export class MaziCraftPlushieSkin extends LitElement {
  static get styles(): CSSResult { return css; }

  /**
   * The image URL
   */
  @property({type: String, reflect: true}) skinUrl = "";

  /**
   * The name
   */
  @property({type: String, reflect: true}) name = "";

  /**
   * Render the plushie thumbnail
   * @returns HTML Template
   */
  render(): TemplateResult {
    return html`
      <div 
        class="container"
      >
        <div class="layer" id="base" style="background-image: url(${this.skinUrl});"></div>
        <div class="layer" id="outer" style="background-image: url(${this.skinUrl});"></div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "maz-plushie-skin": MaziCraftPlushieSkin;
  }
}
